import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import Heading from '@bibliocommons/heading';
import { ExpandableHtml } from '@bibliocommons/expandable';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import CommunityDisclaimer from 'app/components/bibs/shared/ugc/CommunityDisclaimer';
import { CommunityListsContainer } from './CommunityLists';
import { UGCTabsContainer } from './UGCTabs';

import './Community.scss';

export default function Community() {
  const currentLibrary = useSelector(selectCurrentLibrary);
  const intl = useIntl();

  const localizedUgcType = intl.formatMessage({ id: 'contributions' });
  const libraryName = currentLibrary?.get('longName') || intl.formatMessage({ id: 'library_staff' });

  const disclaimerMessage = intl.formatMessage(
    { id: 'ugc_disclaimer_message' },
    { ugcType: localizedUgcType, libraryName }
  );

  return (
    <section className="cp-bib-community container">
      <div className="row">
        <div className="col-lg-3">
          <Heading tagName="h2" size="moderate" variant>
            <FormattedMessage id="community_section" />
          </Heading>
          <div className="cp-bib-community__disclaimer-expandable">
            <ExpandableHtml
              htmlText={disclaimerMessage}
              expandLinkHref="#ugc-disclaimer-read-more"
              dataKey="ugc-disclaimer-read-more-link"
              textKey="ugc_disclaimer"
              truncateCount={150}
            />
          </div>
          <div className="cp-bib-community__disclaimer-simple">
            <CommunityDisclaimer type="contributions" currentLibrary={currentLibrary} />
          </div>
        </div>
        <div className="col-lg-7">
          <CommunityListsContainer />
          <UGCTabsContainer />
        </div>
      </div>
    </section>
  );
}
